import React, {Component} from 'react';
import {Row} from 'react-bootstrap';
import {connect} from 'react-redux';
import {Redirect, withRouter} from 'react-router-dom';
import {fetch_shared_permissions} from './actions'
import DesignResourcesPanel from '../../components/designResourcesPanel/index';
import ImageBox from "../../components/ImageBox";
import ContextMenu from '../../components/contextMenu/index.js';
import ShareLinkModal from '../../components/ShareLinkModal';
import { Fetch } from '../../utils';

const { feline_fetch } = Fetch;

class SharedDesigns extends Component {
    constructor(props) {
        super(props);
        this.state = {
        	shared_designs: [],
            redirect: false,
            redirect_url: null,
            show_share_modal: false,
            design_id: null,
            show_share_modal: false,
        }
    }

    componentDidMount() {
    	if(this.props.user){
            this.props.fetch_shared_permissions()
            .then(permissions => permissions.filter(element => element.resource_type=='design'))
            .then(permissions => {
                var shared_designs = permissions.map(o => {var sd = o.saved_design;sd.role = o.role;return sd});
            	this.setState({shared_designs})
            })
        }
    }

    redirect_page = url => {
        this.setState({redirect_url:url,redirect:true})
    };

    shared_design_on_click = shared_design => {
        this.redirect_page('/designmaker/start/designs/'+ shared_design._id+'/'+shared_design.role)
    };

    copy_design = async design_id => {
        let data = await feline_fetch({ url: 'saved_design/clone_saved_design', body: { saved_design_id: design_id, name_append: ' Copy' } });
        window.open(global.config.website_url + 'designmaker/start/designs/' + data._id +'/edit', '_blank');
    }

    GenerateContextMenu = ({design_id }) => (
        <ContextMenu contextMenuName="your-designs-context-menu" contextMenuOptions={[
            {
                name: 'Share',
                action: e => {
                    e.stopPropagation();
                    this.setState({ 'show_share_modal': true, design_id })
                }
            }, {
                name: 'Make a copy',
                action: e => {
                    e.stopPropagation();
                    this.copy_design(design_id);
                }
            }
        ]}/>
    );

	render() {
        var {redirect, redirect_url} = this.state;
        if (redirect) {
            return (<Redirect push to={redirect_url} />)
        }

		return (
            <div>
                <ShareLinkModal 
                    show_share_modal={this.state.show_share_modal}
                    hide_share_modal={() => this.setState({ show_share_modal: false, design_id: null })}
                    design_id={this.state.design_id}
                    is_saved_design
                />
                <Row>
                    <h3><strong>Shared with you</strong></h3>
                </Row>
                <Row>                    
                    {this.state.shared_designs.length>0 ? this.state.shared_designs.map((element, idx) => (
                    	// <DesignResourcesPanel on_drag_start={()=> {}} on_drag_end={()=> {}} on_click={this.shared_design_on_click} resources={this.state.shared_designs} image_height={'200px'}/>
                        <ImageBox
                            key={'shared-resource-' + element._id}
                            idx={idx}
                            image_src={global.config.static_file_server_path + element.thumbnail}
                            // name={element.name}
                            disable_overlay={true}
                            image_style={{
                                maxWidth: 148,
                                maxHeight: 173,
                                height: 'unset',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                                objectFit: 'contain',
                                display: 'block',
                                boxShadow: '0 0 8px 0 rgba(66,66,66,0.5)'
                            }}
                            container_style={{width: 165}}
                            // footer_text={element.name}
                            context_menu={<this.GenerateContextMenu design_id={element._id} />}
                            on_click={() => this.shared_design_on_click(element)}
                            skeleton={true}
                            skeleton_width={160}
                            skeleton_height={185}
                            boxed_view={true}
                            text_loader={false}
                            max_container_height={185}
                        />
                	)) : ''}

                	{this.state.shared_designs.length == 0 && (
                		<p>You don't have any designs shared with you</p>
            		)}
                </Row>
            </div>
        )

	}
}

const mapStateToProps = function(state) {
    return {
        user: state.user
    }
} 

const mapDispatchToProps = dispatch => {
    return {
        fetch_shared_permissions: () => {
            return dispatch(fetch_shared_permissions())
        }
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SharedDesigns))